/* eslint-disable @typescript-eslint/camelcase */
import store from "@/store";
import { container } from "tsyringe";
import { Action, getModule, Module, VuexModule } from "vuex-module-decorators";
import { HandoverV2Component } from "@/app/infrastructures/dependencies/modules/HandoverV2Component";
import { HandoverV2DetailParams } from "@/data/payload/api/HandoverV2ApiRequest";
import { HandoverV2Presenter } from "../presenters/HandoverV2Presenter";

HandoverV2Component.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "handover-v2"
})
class HandoverV2Store extends VuexModule {
  @Action
  public getDetailHandover(params: HandoverV2DetailParams) {
    const presenter = container.resolve(HandoverV2Presenter);
    return presenter.getDetailHandover(params);
  }
}

export const HandoverV2Controller = getModule(HandoverV2Store);
